<div class="container">
  <h1>Lottery</h1>
  <div class="row">
    <div class="col-md-8 ball-selector-container">
      <app-ball-selector></app-ball-selector>
      <app-game-results></app-game-results>
    </div>
    <div class="col-md-4 bet-slip-container">
      <app-bet-slip></app-bet-slip>
    </div>
  </div>
</div>